import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const UTM_KEY = "nexto_utm", SID_KEY = "nexto_sid";
const KEYS = ["source", "medium", "campaign", "content", "term"];

// First-touch attribution: UTM params from the URL win; otherwise the stored set is kept.
export function captureUtm() {
  const params = new URLSearchParams(window.location.search);
  const found = {};
  KEYS.forEach((k) => { const v = params.get(`utm_${k}`); if (v) found[k] = v.slice(0, 60); });
  if (Object.keys(found).length) {
    try { localStorage.setItem(UTM_KEY, JSON.stringify({ ...found, at: Date.now() })); } catch (e) { /* ignore */ }
  }
  return getUtm();
}

export function getUtm() {
  try { const { at, ...u } = JSON.parse(localStorage.getItem(UTM_KEY) || "{}"); return u; } catch (e) { return {}; }
}

export function getSid() {
  try {
    let sid = sessionStorage.getItem(SID_KEY);
    if (!sid) { sid = (window.crypto?.randomUUID?.() || Math.random().toString(36).slice(2) + Date.now().toString(36)); sessionStorage.setItem(SID_KEY, sid); }
    return sid;
  } catch (e) { return ""; }
}

// Fire-and-forget landing/hero event. `once` dedupes per browser session.
export function track(type, { once = false } = {}) {
  try {
    if (once) { const k = `nexto_ev_${type}`; if (sessionStorage.getItem(k)) return; sessionStorage.setItem(k, "1"); }
    axios.post(`${API}/track`, { type, sid: getSid(), utm: getUtm(), path: window.location.pathname }).catch(() => {});
  } catch (e) { /* ignore */ }
}

export const slug = (s) => String(s).toLowerCase().replace(/[^a-z0-9_]+/g, "-").replace(/(^-|-$)/g, "");

export function buildTrackedLink(base, { source, medium, campaign, content }) {
  const u = new URL(base || "https://hub.nextosoccer.com/");
  u.searchParams.set("utm_source", slug(source));
  u.searchParams.set("utm_medium", slug(medium));
  u.searchParams.set("utm_campaign", slug(campaign));
  if (content) u.searchParams.set("utm_content", slug(content));
  return u.toString();
}
